import { PencilLine } from "lucide-react";

export const editorsLabel = (editors) => {
  if (!editors?.length) {
    return "";
  }
  const [first, ...rest] = editors;
  return rest.length ? `${first.name} +${rest.length} editing` : `${first.name} is editing`;
};

export const EditingBadge = ({ editors, testId, className = "" }) => {
  if (!editors?.length) {
    return null;
  }
  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-violet-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-violet-800 ${className}`} data-testid={testId} title={editors.map((editor) => editor.name).join(", ")}>
      <PencilLine className="h-3 w-3" />
      {editorsLabel(editors)}
    </span>
  );
};
